import React from 'react'
import NavBar from '../../NavBar.component'
import Slider from '../../Slider.component'
import Footer from '../../Footer.component'
import Banner4 from "../../../assets/Banner4.svg";
import Clientele from '../../Home/Clientele.component'
import SolutionVideoCrm from '../SolutionVideoCrm.component'
import CustomScrollbar from '../../CustomScrollbar.component'
import SswayamCrmPro from './SswayamCrmPro.component'
import BasicCrmService from './BasicCrmService.component'
import BasicCrmSales from './BasicCrmSales.component'
import SswayamCrmProService from './SswayamCrmProService.component';
import SswayamCRMStandardCRM from './SswayamCRMStandardCRM.component';
import SwayamProMobileApp from './SwayamProMobileApp.component';

export default function SswayamCrm() {
    return (
        <>
            <section className="">
                {/* NAVIGATION BAR */}
                <section className="">
                    <NavBar />
                </section>

                {/* NAV-CONTACT */}
                <section>{/* <NavContact/> */}</section>

                {/* HERO SLIDER */}
                <section>
                    <Slider images={[Banner4]} showDemoButton={true} />
                </section>

                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section>
                    <BasicCrmSales />
                    <BasicCrmService />
                    <SswayamCrmPro />
                    <SswayamCrmProService />
                    <SswayamCRMStandardCRM />
                    <SwayamProMobileApp />
                </section>

                {/* SOLUTION VIDEO */}
                <section>
                    <SolutionVideoCrm
                        videoSrc1="https://www.youtube.com/embed/9oAO2tMpw2U"
                        videoTitle1="Sswayam CRM Basic (Sales) CRM Application"

                        videoSrc2="https://www.youtube.com/embed/84TMoz6bsew"
                        videoTitle2="Sswayam CRM Basic (Service) CRM Application"

                        videoSrc3="https://www.youtube.com/embed/lURUkpOVa7M"
                        videoTitle3=" Sswayam CRM Pro+(Sales) CRM + Mobile App"
                    />
                </section>

                {/* CLIENTELE */}
                <section>
                    <Clientele />
                </section>

                {/* FOOTER */}
                <section>
                    <Footer />
                </section>

                <CustomScrollbar />
            </section>
        </>
    )
}
